import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageInterface } from '../interfaces/storage.interface';
import { IRegistryCurrentState } from '../interfaces/iregistry-current-state';

@Injectable()
export class RouteStorage implements StorageInterface {
  get queryParams() {
    return this.route.queryParams as Observable<IRegistryCurrentState>;
  }

  constructor(private route: ActivatedRoute, private router: Router) {}

  currentState(): IRegistryCurrentState {
    return Object.assign({}, this.route.snapshot.queryParams);
  }

  defaultState(): void {
    const state = this.currentState();
    state.page = state.page || '1';
    // state.limit = state.limit || '10';
    // state.sort = state.sort || '1';
    // state.sortDirection = state.sortDirection || '1';
    this.changeState(state);
  }

  changeState(newState: IRegistryCurrentState): void {
    const state = Object.assign({}, newState);
    state['page'] = state.page || '1';
    // state['limit'] = state.limit || '10';
    // state['sort'] = state.sort || '1';
    // state['sortDirection'] = state.sortDirection || 'ASC';

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: state,
      fragment: this.route.snapshot.fragment!,
    });
  }
}
